<template>
  <div class="layout">
    <div class="layout_con">
      <top-bar :title="`红色事件-${detailsInfo.title}`"></top-bar>
      <div class="title">
        <div class="item_title">
          {{ detailsInfo.title }}
        </div>
        <img src="@/assets/img/common/title_embellish2.png" alt="" />
      </div>
      <div class="item_content" v-html="detailsInfo.content"></div>
      <div class="to_book">
        <a class="flex" :href="`${STATIC}${detailsInfo.url}`">
          了解更多
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import topBar from '@/components/topBar/index'
import qs from 'qs'
import { STATIC } from '@/request/index.js'
export default {
    metaInfo: {
    title: '具相长安-红色记忆'
  },
  components: {
    topBar
  },
  data() {
    return {
      STATIC: STATIC,
      detailsInfo: {}
    }
  },
  mounted() {
    const { id } = this.$route.params
    this.getDetails(id)
  },
  methods: {
    async getDetails(id) {
      const { content: res } = await this.$http.post(
        '/portal/getBigEventById',
        qs.stringify({
          id
        })
      )
      this.detailsInfo = res
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  .item_title {
    font-size: 0.6133rem;
    color: #222;
    font-weight: bold;
    letter-spacing: 0.0533rem;
    margin-bottom: 0.2667rem;
  }
  img {
    width: 6.1333rem;
  }
}
.item_content {
  padding: 0 0.4rem;
  margin-top: 0.4rem;
  margin-top: 0.3rem;
  font-size: 0.4267rem;
  color: #444;
  letter-spacing: 0.0533rem;
  line-height: 2;
  text-indent: 2em;
}
.to_book {
  display: flex;
  justify-content: center;
  margin: 0.5333rem 0;
  a {
    width: 4.2667rem;
    height: 1.0667rem;
    background: url('../../../assets/img/scenery/btn.png') no-repeat center;
    background-size: 100% 100%;
    font-size: 0.48rem;
    color: #fff;
    letter-spacing: 0.0267rem;
  }
}
</style>
